import { queryOptions } from "@tanstack/react-query";

import { api } from "@platform/core/api";

// Admin telemetry dashboard rows. Mirror the selects in apps/api admin/*.repository.ts.

// One day bucket of cross-tenant usage. `t` is an ISO timestamp. `metered` is
// the lawline tokens already reported to Stripe (the receivable portion).
interface TelemetryPoint {
	t: string;
	lawline: number;
	billable?: number;
	metered: number;
	requests: number;
}

// GET /platform/admin/telemetry. Counts are all-time. Series is the last 30 days.
// The previous* fields are the prior-period values for the card deltas.
interface Telemetry {
	totalTenants: number;
	previousTenants: number;
	totalUsers: number;
	previousUsers: number;
	// Per-lawline-token rate (cents) + currency, for deriving receivable.
	rateCents: number;
	currency: string;
	// Cash received from paid Stripe invoices: current vs prior 30-day window.
	received: { currency: string; current: number; previous: number };
	series: TelemetryPoint[];
}

export const telemetryQueryOptions = queryOptions({
	queryKey: ["admin", "telemetry"],
	queryFn: () => api.get<Telemetry>("/platform/admin/telemetry"),
});
